import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggingService } from './logging.service';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private loggingService: LoggingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Bypass logging for Google Analytics to prevent circular dependency
    if (request.url.includes('google-analytics.com')) {
      return next.handle(request);
    }

    console.log('Outgoing request:', request);
    console.log('Request headers:', request.headers);
    const started = Date.now();
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const elapsed = Date.now() - started;
          this.loggingService.info(
            `Request for ${request.urlWithParams} took ${elapsed} ms.`,
            { request, response: event }
          );
        }
      })
    );
  }
}
